module.exports = __webpack_public_path__ + "public-ui/fonts/cyrillic-ext.56e7ea59.woff2";